import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added for navigation
import '../../assets/styles/OceanFreight.css';

function OceanFreight() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Ocean Freight</title>
        <meta name="description" content="Reliable and cost-effective ocean freight solutions for global shipping." />
      </Helmet>
      <section className="ocean-freight-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="ocean-freight-image img-fluid rounded"
                alt="Ocean Freight Services"
              />
            </div>
            <div className="col-md-6">
              <h2 className="service-title fw-bold mb-4">Ocean Freight Services</h2>
              <p className="service-description">
                Our ocean freight services provide efficient and cost-effective solutions for global shipping. With a vast network of carriers and strategic port partnerships, we ensure secure and timely transport of your goods, from small containers to oversized cargo, across international waters.
              </p>
              <Link to="/contact-us" className="btn btn-contact-us mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OceanFreight;